<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="请输入关键字" prop="out_trade_no" label-width="200">
        <el-input
          v-model="queryParams.out_trade_no"
          placeholder="请输入充电订单号,用户手机号,昵称"
          clearable
          size="small"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="cyan" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="reset()">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="wxxrefundList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
	  <el-table-column label="退款信息" align="center" prop="" >
		  <template slot-scope="scope">
			  <el-tag v-if="scope.row.refundFee ==scope.row.settlementTotalFee"  type="danger">
				  全额退款
			  </el-tag>
			  <el-tag v-if="scope.row.refundFee !=scope.row.settlementTotalFee" type="success">
			  				  部分退款
			  </el-tag>
		  </template>
	  </el-table-column>
      <el-table-column label="充电订单" align="center" prop="chargeOrderNumber" />
	  <el-table-column label="用户名" align="center" prop="chargeUserName" />
	  <el-table-column label="手机号" align="center" prop="chargeUserPhone" />
      <el-table-column label="支付交易号码" align="center" prop="outTradeNo" />
	  <el-table-column label="商户退款单号" align="center" prop="outRefundNo" />
      <!-- <el-table-column label="商户订单号" align="center" prop="out_trade_no" /> -->
      <!-- <el-table-column label="退款账户" align="center" prop="refund_account" /> -->
      <el-table-column label="退款金额" align="center" prop="refundFee" />
      <!-- <el-table-column label="退费ID" align="center" prop="refundId" /> -->
      <el-table-column label="退款接收账户" align="center" prop="refundRecvAccount" />
      <el-table-column label="退款状态" align="center" prop="refundStatus" />
      <el-table-column label="应结退款金额" align="center" prop="settlementRefundFee" />
      <el-table-column label="应结订单金额" align="center" prop="settlementTotalFee" />
      <el-table-column label="订单金额" align="center" prop="totalFee" />
      <!-- <el-table-column label="微信支付订单号" align="center" prop="transaction_id" /> -->
      <el-table-column label="成功时间" align="center" prop="successTime" width="180">
      </el-table-column>
      <!-- <el-table-column label="退款原因" align="center" prop="refundDesc" /> -->
      <!-- <el-table-column label="退款币种" align="center" prop="refundFeeType" /> -->
     
    </el-table>
    
     <div style="display: flex;justify-content: flex-end">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total, slot"
          :total="total"
        ></el-pagination>
      </div>
    
  </div>
</template>

<script>
import { listWxxrefund} from "./wxxrefund";

export default {
  name: "Wxxrefund",
  components: {
  },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 微信退款表格数据
      wxxrefundList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        page: 1,
        size: 10,
        out_trade_no: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询微信退款列表 */
    getList() {
      this.loading = true;
      listWxxrefund(this.queryParams).then(response => {
        this.wxxrefundList = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {};
      this.queryParams.out_trade_no=null;
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryParams");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    }
    ,
    sizeChange(currentSize) {
      this.queryParams.size = currentSize;
      this.getList();
    },
    // 选择页
    currentChange(currentPage) {
      this.queryParams.page = currentPage;
      this.getList("advanced");
    }
  }
};
</script>
